import React from 'react';
import { AboutSection } from '../components/AboutSection';
import { SolutionsSection } from '../components/SolutionsSection';
export function AboutPage() {
  return <div className="pt-28" data-id="element-444">
      <AboutSection data-id="element-445" />
      <SolutionsSection data-id="element-446" />
    </div>;
}